import React from 'react';


interface ScioCountdownProps {
    examDate: Date;
    subjectName: string;
}

export const ScioCountdown: React.FC<ScioCountdownProps> = ({ examDate, subjectName }) => {
    const today = new Date();
    // Reset time part for accurate day calculation
    const todayReset = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const examReset = new Date(examDate.getFullYear(), examDate.getMonth(), examDate.getDate());

    const diffTime = examReset.getTime() - todayReset.getTime();
    const daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Determine color based on remaining days
    let numberColor = 'text-gray-400';
    let pulseClass = '';

    if (daysRemaining < 7) {
        numberColor = 'text-red-500';
        pulseClass = 'animate-pulse';
    } else if (daysRemaining < 14) {
        numberColor = 'text-red-500';
    } else if (daysRemaining < 30) {
        numberColor = 'text-orange-500';
    }

    const formatDate = (date: Date) => {
        const days = ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'];
        const months = ['ledna', 'února', 'března', 'dubna', 'května', 'června', 'července', 'srpna', 'září', 'října', 'listopadu', 'prosince'];

        const dayName = days[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        return `${dayName}, ${day}. ${month} ${year}`;
    };

    return (
        <div className="bg-card dark:bg-[#1F2937] rounded-3xl p-6 shadow-sm border border-border/50 flex flex-col items-center justify-center text-center h-full min-h-[200px]">
            <div className="flex items-center gap-2 mb-4">
                <span className="text-xl">🎯</span>
                <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider">SCIO: {subjectName}</span>
            </div>

            <div className={`text-7xl font-bold mb-2 transition-colors duration-300 ${numberColor} ${pulseClass}`}>
                {Math.max(0, daysRemaining)}
            </div>

            <div className="text-xs font-bold text-muted-foreground tracking-[0.2em] mb-6">DnÍ ZBÝVÁ</div>

            <div className="text-muted-foreground font-medium">
                {formatDate(examDate)}
            </div>
        </div>
    );
};
